import React, { Fragment } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import PageTitleAlt2 from '../../Layout/AppMain/PageTitle';

export default function Main() {
    return (
        <Fragment>
            <CSSTransitionGroup
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <PageTitleAlt2
                    heading="Home"
                    subheading="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                    icon="pe-7s-graph icon-gradient bg-ripe-malin"
                />
            </CSSTransitionGroup>
        </Fragment>
    );
}
